import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-message',
  templateUrl: './message.component.html',
})
export class ModalMessageComponent {
  constructor(public modal: ModalService) {}
}
